import {useQuery} from 'react-query'
import {TApiResponse} from '../../../../types/api'
import {getErrorToast} from '../../../helpers/toasts'
import api from '../../../../api'

const useTest = <T = any>(object: string, requestData: any, enabled = true) => {
    return useQuery<TApiResponse<T>, unknown, T | null>(
        [object, requestData],
        () => api(object, 'get', requestData) as Promise<TApiResponse<T>>,
        {
            retry: false,
            refetchOnWindowFocus: false,
            enabled,
            keepPreviousData: true,
            select: (response: TApiResponse<T>) => {
                const raw: any = response.data
                return (Array.isArray(raw) ? raw[0] : raw) ?? null
            },
            onError: (error: any) => getErrorToast(error?.message ?? 'Ошибка загрузки'),
        }
    )
}

export default useTest
